var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "goods" }, [
    _c("div", { staticClass: "goods-img" }, [
      _c("img", {
        attrs: { src: _vm.good.productImages.split(",")[0], alt: "" }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.disShow,
              expression: "disShow"
            }
          ],
          staticClass: "dis"
        },
        [
          _vm._v(
            "约赚¥" +
              _vm._s(
                _vm.good.maxStoreProfit
                  ? _vm.good.maxStoreProfit.toFixed(2)
                  : "0.00"
              )
          )
        ]
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "goods-detail" },
      [
        _c("p", { staticClass: "goodstitle" }, [_vm._v(_vm._s(_vm.good.name))]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "goodIntegral" },
          [
            _vm.good.maxDeductionAmount
              ? _c("integralDeduction", { attrs: { goodData: _vm.good } })
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _vm.good.isMarketable === 2
          ? _c("p", { staticClass: "goodsprice" }, [
              _vm._v("¥\n            "),
              _c("span", [
                _vm._v(_vm._s(_vm.good.minPrice.toString().split(".")[0]))
              ]),
              _vm.good.minPrice.toString().split(".").length === 2
                ? _c("span", { staticClass: "minMoney" }, [
                    _vm._v(
                      "." + _vm._s(_vm.good.minPrice.toString().split(".")[1])
                    )
                  ])
                : _vm._e()
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.good.isMarketable === 2
          ? _c(
              "van-row",
              { staticClass: "buydata" },
              [
                _vm.good.salesNum >= 10000 && _vm.good.salesNum <= 100000000
                  ? _c("van-col", { attrs: { span: "8" } }, [
                      _vm._v(
                        _vm._s(parseInt(_vm.good.salesNum / 10000) + "万") +
                          "人付款"
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.good.salesNum >= 10000000
                  ? _c("van-col", { attrs: { span: "8" } }, [
                      _vm._v(
                        _vm._s(parseInt(_vm.good.salesNum / 100000000) + "亿") +
                          "人付款"
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.good.salesNum <= 9999 && _vm.good.salesNum > 0
                  ? _c("van-col", { attrs: { span: "8" } }, [
                      _vm._v(_vm._s(_vm.good.salesNum) + "人付款")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.good.salesNum || _vm.good.salesNum === 0
                  ? _c("van-col", { attrs: { span: "8" } }, [_vm._v("0人付款")])
                  : _vm._e(),
                _vm._v(" "),
                _c("van-col", { attrs: { span: "8" } }, [
                  _vm._v(
                    _vm._s(_vm.good.goodPoint ? _vm.good.goodPoint : 0) +
                      "%好评"
                  )
                ])
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.good.isMarketable === 1
          ? _c("p", { staticClass: "sxP" }, [_vm._v("失效")])
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }